import { render } from "./DashboardData.vue?vue&type=template&id=94119716&scoped=true"
import script from "./DashboardData.vue?vue&type=script&lang=js"
export * from "./DashboardData.vue?vue&type=script&lang=js"

import "./DashboardData.vue?vue&type=style&index=0&id=94119716&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94119716"]])

export default __exports__